import { render, staticRenderFns } from "./MemberOrganizations.vue?vue&type=template&id=51917e4c&"
import script from "./MemberOrganizations.vue?vue&type=script&lang=js&"
export * from "./MemberOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports